'use strict';

var isJQuery = require('./is-jquery');

/**
 * Verifica che l'elemento sia un oggetto jquery vuoto
 *
 * @param value
 * @returns {boolean}
 */
module.exports = function isEmptyJQuery(value) {
    return isJQuery(value) && value.length === 0;
};
